/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalsignin_Passkey_ButtonInputs */

const en_portalsignin_passkey_button = /** @type {(inputs: Portalsignin_Passkey_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with a passkey`)
};

/** @type {(inputs: Portalsignin_Passkey_ButtonInputs) => LocalizedString} */
const ar_portalsignin_passkey_button = en_portalsignin_passkey_button;

/** @type {(inputs: Portalsignin_Passkey_ButtonInputs) => LocalizedString} */
const he_portalsignin_passkey_button = en_portalsignin_passkey_button;

/** @type {(inputs: Portalsignin_Passkey_ButtonInputs) => LocalizedString} */
const ur_portalsignin_passkey_button = en_portalsignin_passkey_button;

/** @type {(inputs: Portalsignin_Passkey_ButtonInputs) => LocalizedString} */
const es_portalsignin_passkey_button = en_portalsignin_passkey_button;

/** @type {(inputs: Portalsignin_Passkey_ButtonInputs) => LocalizedString} */
const fr_portalsignin_passkey_button = en_portalsignin_passkey_button;

/** @type {(inputs: Portalsignin_Passkey_ButtonInputs) => LocalizedString} */
const de_portalsignin_passkey_button = en_portalsignin_passkey_button;

/** @type {(inputs: Portalsignin_Passkey_ButtonInputs) => LocalizedString} */
const pt_portalsignin_passkey_button = en_portalsignin_passkey_button;

/** @type {(inputs: Portalsignin_Passkey_ButtonInputs) => LocalizedString} */
const hi_portalsignin_passkey_button = en_portalsignin_passkey_button;

/** @type {(inputs: Portalsignin_Passkey_ButtonInputs) => LocalizedString} */
const bn_portalsignin_passkey_button = en_portalsignin_passkey_button;

/**
* | output |
* | --- |
* | "Sign in with a passkey" |
*
* @param {Portalsignin_Passkey_ButtonInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalsignin_passkey_button = /** @type {((inputs?: Portalsignin_Passkey_ButtonInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalsignin_Passkey_ButtonInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalsignin_passkey_button(inputs)
	if (locale === "he") return he_portalsignin_passkey_button(inputs)
	if (locale === "ur") return ur_portalsignin_passkey_button(inputs)
	if (locale === "es") return es_portalsignin_passkey_button(inputs)
	if (locale === "fr") return fr_portalsignin_passkey_button(inputs)
	if (locale === "de") return de_portalsignin_passkey_button(inputs)
	if (locale === "pt") return pt_portalsignin_passkey_button(inputs)
	if (locale === "hi") return hi_portalsignin_passkey_button(inputs)
	if (locale === "bn") return bn_portalsignin_passkey_button(inputs)
	return /** @type {LocalizedString} */ ("Sign in with a passkey")
});